import { JtechAxios } from 'src/plugins/axios'

export const MtrRepository = {
  downloadMtr: async function (mtrCode) {
    JtechAxios.request
    return await JtechAxios.request().get(`mtr/download/${mtrCode}`, {
      responseType: 'blob',
      headers: { Accept: 'application/pdf' }
    })
  }
}
